// Page-0 reconciliation for the Event History background delta refresh.
//
// In DESCENDING order new events land on page 0. When the refresh re-fetches
// page 0 and finds new rows, the boundary moved: deeper cached pages (>= 1) are
// stale and dropped, and the frontier resets to 0. (In ASCENDING order page 0
// is the oldest rows and never changes, so this no-ops.)
//
// Mutates `pageCache` in place (sets page 0; on change deletes pages >= 1) and
// returns { changed, tokenStack, frontier } — the reset values to apply when
// changed, both null otherwise. Extracted from revalidateDelta to be testable.
export function reconcilePage0(prevItems, items, nextToken, pageCache) {
  const rowId = (r) => (r && (r.audit_id || r.timestamp)) || null;
  const prev = prevItems || [];

  // New rows at the top shift the boundary. Compare count + newest row id.
  const changed = prev.length !== items.length || rowId(prev[0]) !== rowId(items[0]);

  pageCache.set(0, { items, nextToken: nextToken || null });

  if (!changed) {
    return { changed: false, tokenStack: null, frontier: null };
  }

  for (const idx of Array.from(pageCache.keys())) {
    if (idx >= 1) pageCache.delete(idx);
  }
  return {
    changed: true,
    tokenStack: nextToken ? [null, nextToken] : [null],
    frontier: { max: 0, more: nextToken !== null },
  };
}
